module.exports = __webpack_public_path__ + "img/plus.7b5ddeec.svg";